"use strict";

function _classCallCheck(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function _createClass(e, t, r) {
  return t && _defineProperties(e.prototype, t), r && _defineProperties(e, r), e;
}
var Converter = function () {
  return _createClass(function e() {
    _classCallCheck(this, e);
  }, [{
    key: "createimg",
    value: function (e, t, r, n, a, l, i) {
      var o = 50,
        c = 50,
        u = "Arial",
        s = "normal";
      null != a && (o = a), null != n && (c = n), null != l && (s = l), null != i && (u = i);
      var f = document.createElement("canvas");
      f.width = Number(c), f.height = Number(o);
      var m = f.getContext("2d");
      m.createLinearGradient(0, 0, f.width, 0), m.font = e + "px " + u, m.fontweight = s, m.fillStyle = t;
      var v = r;
      m.fillText(v, 1, 25);
      var d = document.createElement("img");
      return d.src = f.toDataURL(), console.log(d), d;
    }
  }]);
}();
module.exports = {
  imageConverter: Converter
}, exports.createimg2 = function (e, t, r, n, a, l, i) {
  var o = 50,
    c = 50,
    u = "Arial",
    s = "normal";
  null != a && (o = a), null != n && (c = n), null != l && (s = l), null != i && (u = i);
  var f = document.createElement("canvas");
  f.width = Number(c), f.height = Number(o);
  var m = f.getContext("2d");
  m.createLinearGradient(0, 0, f.width, 0), m.font = e + "px " + u, m.fontweight = s, m.fillStyle = t;
  var v = r;
  m.fillText(v, 1, 25);
  var d = document.createElement("img");
  return d.src = f.toDataURL(), d;
};